/**
 * @desc 根据平台编号查询平台信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.PlatformResponseDto>;
export function request(
  params: API.basics.platformFacadeImpl.getPlatformInfoByKey.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/platform/getPlatformInfoByKey`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
